import { Box, Typography, useTheme } from '@mui/material';

interface Props {
  statusId: number;
}

export default function RcaStatusText({ statusId }: Props) {
  const { palette } = useTheme();
  const statusText = {
    1: 'Draft',
    2: 'In Progress',
    3: 'Complete',
  };

  const statusIndicatorColor = {
    1: '#B9C3CA',
    2: palette.blue.dark,
    3: palette.success.main,
  };

  const statusTextColor = {
    1: '#636D73',
    2: palette.blue.dark,
    3: palette.success.main,
  };

  return (
    <Box
      className="status"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: 24,
        gap: '10px',
      }}
    >
      <Box
        sx={{
          width: '9px',
          height: '9px',
          borderRadius: 9,
          background: statusIndicatorColor[statusId],
        }}
      />
      <Typography
        sx={{
          fontSize: '14px',
          color: statusTextColor[statusId],
        }}
      >
        {statusText[statusId]}
      </Typography>
    </Box>
  );
}
